
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetoprayagrajcab() {



    const cardData =
    {
        keyword: 'Pune to Prayagraj Cab',
        heading: 'S9 Travels: Pune to Prayagraj Cab',
        headingDescription: 'S9 Travels offers Pune to Prayagraj Cab Service, providing a comfortable, safe, and hassle-free journey to the sacred city. Whether you are visiting for pilgrimage or leisure, our well-maintained cabs, including spacious Innova vehicles, ensure a smooth and enjoyable ride. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Pune to Prayagraj Cab with S9 Travels and travel stress-free to this historic destination!',


        top: 'Top Places to Visit in Prayagraj with S9 Travels',

"topPlaces": [
    {
      "title": "Triveni Sangam",
      "description": "The sacred confluence of the Ganga, Yamuna, and the mythical Saraswati rivers, Triveni Sangam is one of the holiest places in Hinduism. Pilgrims take a dip here to cleanse their sins, and it is the main site for the Kumbh Mela, the world's largest religious gathering."
    },
    {
      "title": "Allahabad Fort",
      "description": "Built by Emperor Akbar in 1583, the grand Allahabad Fort stands on the banks of the Yamuna River. It houses the sacred Akshaya Vat (immortal banyan tree) and the mysterious Saraswati Koop, believed to be the source of the mythical Saraswati River."
    },
    {
      "title": "Anand Bhavan",
      "description": "The ancestral home of the Nehru family, Anand Bhavan has been converted into a museum showcasing artifacts, books, and photographs related to India's freedom movement. It is a must-visit for history enthusiasts."
    },
    {
      "title": "Khusro Bagh",
      "description": "A stunning Mughal-era garden and burial complex, Khusro Bagh is the resting place of Prince Khusro, the son of Emperor Jahangir. The intricate Mughal architecture and peaceful atmosphere make it a great place for history lovers."
    },
    {
      "title": "All Saints Cathedral",
      "description": "Also known as Patthar Girja, All Saints Cathedral is a magnificent Gothic-style church built during the British era. Its stunning stained-glass windows and intricate carvings make it a significant landmark in Prayagraj."
    },
    {
      "title": "Company Bagh",
      "description": "Also known as Chandrashekhar Azad Park, Company Bagh is a lush green park that serves as a peaceful retreat for visitors. It houses the statue of freedom fighter Chandrashekhar Azad, who martyred himself here."
    },
    {
      "title": "Bade Hanuman Mandir",
      "description": "Situated near Triveni Sangam, Bade Hanuman Mandir is unique as it features a giant reclining idol of Lord Hanuman submerged in the ground. Devotees believe that visiting this temple fulfills their wishes."
    },
    {
      "title": "Mankameshwar Temple",
      "description": "One of the oldest temples in Prayagraj, Mankameshwar Temple is dedicated to Lord Shiva. It is located near Saraswati Ghat and attracts devotees, especially during Shivratri."
    },
    {
      "title": "Nag Vasuki Temple",
      "description": "Located in Daraganj, this ancient temple is dedicated to Lord Vasuki (the king of serpents). It is a significant pilgrimage site, especially during Nag Panchami."
    },
    {
      "title": "Minto Park (Madan Mohan Malaviya Park)",
      "description": "A historically significant park where the British officially declared the change of India's capital from Allahabad to Delhi in 1911. The park now serves as a peaceful place for visitors."
    }
],

"services": [
  {
    "name": "Pune to Prayagraj Cab Service",
    "description": "Book a reliable and comfortable cab from Pune to Prayagraj with S9 Travels. Whether you're traveling for spiritual purposes or leisure, we offer both one-way and round-trip services tailored to your needs. Our experienced drivers ensure a smooth, safe, and comfortable journey to this holy city, letting you focus on your pilgrimage or exploration while we handle the rest."
  },
  {
    "name": "Book Pune to Prayagraj Taxi",
    "description": "Booking a taxi from Pune to Prayagraj is made easy with S9 Travels. Whether you prefer a one-way trip or need the flexibility of a round-trip, we provide affordable and reliable taxi services. Our fleet of well-maintained vehicles ensures that your journey is comfortable, while our professional chauffeurs guarantee a safe and timely arrival at your destination."
  },
  {
    "name": "Affordable Pune to Prayagraj Cab",
    "description": "Travel affordably from Pune to Prayagraj with S9 Travels. We offer budget-friendly cab services that don't compromise on quality. Our comfortable and well-maintained vehicles, along with experienced drivers, make it possible to travel economically while ensuring a smooth and safe journey, whether you are on a pilgrimage or a leisure trip."
  },
  {
    "name": "Private Taxi for Prayagraj from Pune",
    "description": "Travel privately and comfortably with a dedicated taxi from Pune to Prayagraj. Our private taxis are ideal for those who prefer a more intimate and personalized travel experience. With a range of vehicle options and experienced drivers, your journey to Prayagraj will be relaxing and efficient, ensuring that you reach your destination in comfort and style."
  },
  {
    "name": "Prayagraj Pilgrimage Taxi from Pune",
    "description": "Embark on your pilgrimage to Prayagraj from Pune with S9 Travels' specialized pilgrimage taxis. We offer a fleet of vehicles specifically suited for long-distance spiritual journeys. Our drivers are well-trained in handling long-distance travel and ensure a peaceful, safe, and comfortable ride to one of India’s most important spiritual cities."
  },
  {
    "name": "Pune to Prayagraj One-Way or Round Trip",
    "description": "Whether you are looking for a one-way trip or a round-trip journey, S9 Travels provides flexible taxi options for your travel from Pune to Prayagraj. Choose the option that suits your itinerary, and enjoy a hassle-free, comfortable ride with our professional drivers ensuring timely and safe travel."
  },
  {
    "name": "Luxury Cab from Pune to Prayagraj",
    "description": "Travel in luxury with S9 Travels' premium cabs from Pune to Prayagraj. We offer luxury vehicles, including SUVs and sedans, for travelers who want to experience maximum comfort and style during their journey. With professional chauffeurs and high-end amenities, you can enjoy a premium travel experience to this revered destination."
  },
  {
    "name": "Prayagraj Temple Tour by Taxi",
    "description": "Book a dedicated taxi for your Prayagraj temple tour from Pune. Whether you're visiting the Triveni Sangam, Kumbh Mela, or other sacred sites, our taxis offer the best comfort and convenience. Our drivers are well-acquainted with the city's temple routes and will guide you safely, ensuring that your pilgrimage experience is as peaceful and fulfilling as possible."
  },
  {
    "name": "Comfortable Taxi Service for Prayagraj",
    "description": "Experience a comfortable and relaxing taxi service for your journey from Pune to Prayagraj. Our fleet of well-maintained vehicles, combined with our experienced chauffeurs, ensures a smooth ride to the holy city. With a focus on passenger comfort, we guarantee a stress-free and enjoyable journey to your destination."
  },
  {
    "name": "Group Travel to Prayagraj from Pune",
    "description": "Planning a group pilgrimage to Prayagraj from Pune? S9 Travels offers spacious cabs that can accommodate large groups, making your journey comfortable and enjoyable. Whether you're traveling with family, friends, or a religious group, our taxis offer ample space and a comfortable ride for everyone, ensuring a smooth experience for all."
  }
],

"tableData": [
  ["Pune to Prayagraj Cab Service", "Book Pune to Prayagraj Taxi"],
  ["Affordable Pune to Prayagraj Cab", "Private Taxi for Prayagraj from Pune"],
  ["Prayagraj Pilgrimage Taxi from Pune", "Pune to Prayagraj One-Way or Round Trip"],
  ["Luxury Cab from Pune to Prayagraj", "Prayagraj Temple Tour by Taxi"],
  ["Comfortable Taxi Service for Prayagraj", "Group Travel to Prayagraj from Pune"],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Pune to Prayagraj cab service, ideal for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Pune to Prayagraj cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for trips from Pune to Prayagraj. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Pune to Prayagraj cab service. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Prayagraj Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your trip from Pune to Prayagraj."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Pune to Prayagraj trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Prayagraj Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your Pune to Prayagraj journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Pune to Prayagraj cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]

















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Prayagraj with S9 Travels?',
            answer: 'Booking a cab from Pune to Prayagraj is simple! You can easily book your ride through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and seamless journey to Prayagraj.',
          },
          {
            question: 'What types of vehicles are available for a trip from Pune to Prayagraj?',
            answer: 'We offer a variety of vehicles for your trip from Pune to Prayagraj, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that best suits your needs based on your group size and preferences.',
          },
          {
            question: 'Are the drivers experienced for the Pune to Prayagraj trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for the Pune to Prayagraj journey. They prioritize your safety, comfort, and a smooth travel experience.',
          },
          {
            question: 'Can I book a round-trip cab from Pune to Prayagraj?',
            answer: 'Yes, you can book a round-trip cab for your journey from Pune to Prayagraj. Just provide us with your return details, and we will ensure a timely and hassle-free return journey.',
          },
          {
            question: 'How long in advance should I book a cab for Pune to Prayagraj?',
            answer: 'It is recommended to book your cab at least 1-2 days in advance to secure vehicle availability. However, last-minute bookings are also possible based on availability.',
          },
          {
            question: 'Is there a fixed fare for the Pune to Prayagraj cab service?',
            answer: 'The fare for the Pune to Prayagraj trip depends on the distance, vehicle type, and other specific requirements. Contact us for a personalized quote with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Pune airport or hotels for the Prayagraj trip?',
            answer: 'Yes, we offer convenient pick-up services from Pune airport or hotels. Our professional drivers will ensure smooth transfer to your cab for a comfortable journey to Prayagraj.',
          },
          {
            question: 'Can I request additional stops along the way during my trip to Prayagraj?',
            answer: 'Yes, we can customize your itinerary by adding stops for meals, sightseeing, or other breaks during your journey to Prayagraj. Inform us at the time of booking to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Pune to Prayagraj trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process. We maintain full transparency in our pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Prayagraj trip?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Pune to Prayagraj. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Pune to Prayagraj with S9 Travels, and the experience was fantastic. The driver was courteous and professional, and the vehicle was clean and comfortable. The journey was smooth, and we arrived in Prayagraj on time. I highly recommend their services for long-distance trips!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Pune to Prayagraj with S9 Travels was amazing. The vehicle was spacious and well-maintained, and the driver was skilled and friendly. We enjoyed the journey, and the trip was very comfortable. We’ll definitely use S9 Travels again for our future travels.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Prayagraj Cab",
        "description": "Book affordable and reliable Pune to Prayagraj cab services for one-way trips, round trips, and pilgrimage tours. S9 Travels offers private taxi rides for a comfortable and scenic journey from Pune to Prayagraj, perfect for group travel, temple visits, and religious tours.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Pune to Prayagraj Cab | Affordable Taxi & Pilgrimage Travel | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Prayagraj taxi services, including one-way, round-trip, and private cabs. Comfortable and affordable transport for pilgrimage trips, group travel, and temple tours from Pune to Prayagraj with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
     
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoprayagrajcab;